import React, { useState } from "react";
import { Container, Row, Col, Button, Tab, Nav, Card } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import SingleFamilyHome from '../assets/images/icons/sfh.svg'
import TownhouseTownhome from '../assets/images/icons/tt.svg'
import DuplexTriplexFourplex from '../assets/images/icons/dtf.svg'
import Apartment from '../assets/images/icons/apr.svg'
import Condominium from '../assets/images/icons/cond.svg'
import Villa from '../assets/images/icons/apr.svg'
import Bungalow from '../assets/images/icons/bun.svg'
import Mansion from '../assets/images/icons/man.svg'
import Land from '../assets/images/icons/land.svg'

import OfficeBuildings from '../assets/images/icons/ob.svg'
import RetailProperties from '../assets/images/icons/rp.svg'
import IndustrialProperties from '../assets/images/icons/ip.svg'
import MultifamilyApartments from '../assets/images/icons/ma.svg'

import Buy from '../assets/images/icons/buy.svg'
import Mortgage from '../assets/images/icons/mortgage.svg'
import Sell from '../assets/images/icons/sell.svg'
import Rent from '../assets/images/icons/rent.svg'

import smallLogo from '../assets/images/logo.png'
import grayArrow from '../assets/images/icons/gray-arrow.svg'
import backArrow from '../assets/images/icons/back-arrow.svg'
import { Link } from "react-router-dom";


const PropertyTypeSelector = () => {
  const [view, setView] = useState("tabs");
  const [activeTab, setActiveTab] = useState("residential");
  const [url, setUrl] = useState('')
  const [category, setCategory] = useState('')
  const [listing_type, setListingType] = useState('')
  const [property_type, setPropertyType] = useState('')

  function setParams(type, title) {
    setPropertyType(type)
    setCategory(title)
    if(property_type=="residential"){
      if(listing_type=="sale"){
        setUrl(`buy?property_type=${property_type}&;isting_type=sale&category=${category}`)
      }else{
        setUrl(`buy?property_type=${property_type}&;isting_type=sale&category=${category}`)
      }
    }


  }
  console.log(category)
  console.log(listing_type)
  console.log(property_type)


  const residential = [
    { title: "Single-Family Home", img: SingleFamilyHome },
    { title: "Townhouse / Townhome", img: TownhouseTownhome },
    { title: "Duplex / Triplex / Fourplex", img: DuplexTriplexFourplex },
    { title: "Apartment", img: Apartment },
    { title: "Condominium", img: Condominium },
    { title: "Villa", img: Villa },
    { title: "Bungalow", img: Bungalow },
    { title: "Mansion", img: Mansion },
    { title: "Land", img: Land },
  ];

  const commercial = [
    { title: "Office Buildings", slug:'office_building', img: OfficeBuildings },
    { title: "Retail Properties", slug:'retail', img: RetailProperties },
    { title: "Industrial Properties", slug:'industrial', img: IndustrialProperties },
    { title: "Multifamily Apartments", slug:'multi_family', img: MultifamilyApartments },

  ];

  const services = [
    {
      title: "Buy",
      desc: "Find local agents to guide you through buying your dream home.",
      btn: "Explore Properties",
      img: Buy,
      url: property_type === "residential"
      ? `buy?property_type=${property_type}&listing_type=sale&category=${category}`
      : `commercial?property_type=${property_type}&listing_type=sale&category=${category}`

    },
    {
      title: "Mortgage",
      desc: "Get the best mortgage advice and rates for your home purchase.",
      btn: "Get Prequalified",
      img: Mortgage,
      url: '/mortgage-calculator'
    },
    {
      title: "Sell",
      desc: "Learn how to sell your property for the best price and terms.",
      btn: "Learn More",
      img: Sell,
      url: '/sell'
    },
    {
      title: "Rent",
      desc: "Whether you’re searching or listing, explore rental options.",
      btn: "Explore Rentals",
      img: Rent,
       url: property_type === "residential"
      ? `rent?property_type=${property_type}&listing_type=rent&category=${category}`
      : `commercial?property_type=${property_type}&listing_type=rent&category=${category}`
    },
  ];

  return (

    <div className="home-see-how-can-help  common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>See how  <span>JamboBay</span> can help</h2>
          <p>Your trusted partner in buying, selling, and renting property.</p>
        </div>
      </Container>
      {view === "tabs" && (
        <Tab.Container
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k || "residential")}
        >
          <Nav variant="pills" >
            <Nav.Item>
              <Nav.Link eventKey="residential">Residential</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="commercial">Commercial</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="residential">
              <Swiper
                spaceBetween={16}
                slidesPerView={1.3}
                freeMode={true}
                watchOverflow={true}
                centerInsufficientSlides={true}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  576: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  992: { slidesPerView: 4 },
                  1599: { slidesPerView: 7 },
                }}
                pagination={{ clickable: true }}
                modules={[Pagination, Autoplay]}
              >
                {residential.map((item, i) => (
                  <SwiperSlide key={i}>
                    <Card
                      onClick={() => {
                        setView("details");
                        setParams("residential", item.title);
                      }}

                    >
                      <Card.Body>
                        <img src={item.img} alt="" />
                        <Card.Title>{item.title}</Card.Title>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Tab.Pane>

            <Tab.Pane eventKey="commercial">
              <Swiper
                spaceBetween={16}
                slidesPerView={1.3}
                freeMode={true}
                watchOverflow={true}
                centerInsufficientSlides={true}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  576: { slidesPerView: 2 },
                  768: { slidesPerView: 3 },
                  992: { slidesPerView: 4 },
                  1599: { slidesPerView: 7 },
                }}
                pagination={{ clickable: true }}
                modules={[Pagination, Autoplay]}
              >
                {commercial.map((item, i) => (
                  <SwiperSlide key={i}>
                    <Card
                     onClick={() => {
                        setView("details");
                        setParams("commercial", item.slug);
                      }}
                    >
                      <Card.Body>
                        <img src={item.img} alt="" />
                        <Card.Title>{item.title}</Card.Title>
                      </Card.Body>
                    </Card>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      )}
      {view === "details" && (
        <>
          <Container>
            <Row className="details-view">
              {services.map((srv, idx) => (
                <Col key={idx} md={6} lg={3}>
                  <Card>
                    <Card.Body>
                      <img src={srv.img} alt="" />
                      <Card.Title>{srv.title}</Card.Title>
                      <Card.Text>
                        {srv.desc}
                      </Card.Text>
                      <Link to={`${srv.url}`} title={''} className="custom-bttn style-2 ani-1">
                        {srv.btn} <img src={grayArrow} alt="" />
                      </Link>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            <div className="back-arrow-wrap">
              <Button className="custom-bttn back-button" onClick={() => setView("tabs")}>
                <img src={backArrow} alt="" /> Back to Property Type
              </Button>
            </div>
          </Container>
        </>
      )}
    </div>
  );
};

export default PropertyTypeSelector;
